module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('div', {
    staticClass: "wrapper- wrapper-full-page- section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("You've found a loophole")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fas fa-bullhorn"
  }), _vm._v("   But it seems that this page doesn't lead anywhere")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460a2a49","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeneralViews/NotFound.vue
// module id = 9IEU
// module chunks = 13 14